import styled, {css} from 'styled-components';

import type {StyledModalBodyContainerProps, StyledQuoteAlertProps} from './typings';

import breakpoints from '@/theme/constants/breakpoints';
import colors from '@/theme/constants/colors';
import typography from '@/theme/typography';
import {sizePx} from '@/theme/helpers/size';

export const StyledModalBodyContainer = styled.div<StyledModalBodyContainerProps>`
  padding: ${sizePx(8)} ${sizePx(10)};
  display: flex;
  flex-direction: column;
  gap: ${sizePx(4)};
  min-height: 382px;
  opacity: ${({$isLoading}) => ($isLoading ? 0.7 : 1)};
  transition: opacity 0.7s ease-in-out;

  @media only screen and ${breakpoints.device.s} {
    min-width: 440px;
  }
`;

export const StyledDisplayShippingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizePx(10)};
  border-top: 1px solid ${colors.grey50};
  border-bottom: 1px solid ${colors.grey50};
  padding-top: ${sizePx(8)};
  padding-bottom: ${sizePx(3)};

  & > div {
    ${typography.Body2}
    display: flex;
    flex-direction: column;
    & p {
      ${typography.Body1}
    }
    & b {
      ${typography.Subtitle1}
    }
    & a {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export const StyledModalContainer = styled.div`
  & div[class*='StyledTopMenu'] {
    top: ${sizePx(8)};
    right: ${sizePx(8)};
  }
`;

export const StyledModalTitle = styled.div`
  ${typography.Subtitle1}
  margin-bottom: ${sizePx(6)};
`;

export const StyledAddressSummary = styled.p`
  & > b {
    ${typography.Subtitle1}
  }
  & > small {
    ${typography.Body1}
    color: ${colors.darkBlue75};
  }
`;

export const StyledQuoteAlert = styled.div<StyledQuoteAlertProps>`
  background-color: ${colors.grey25};
  padding: ${sizePx(8)} ${sizePx(8)} ${sizePx(14)} ${sizePx(8)};
  margin-bottom: ${sizePx(6)};
  border-radius: ${sizePx(2)};
  min-height: 116px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: ${sizePx(2)};
  justify-content: center;
  ${({$variant}) =>
    $variant !== 'quoted' &&
    css`
      & > p {
        color: ${colors.red100};
      }
    `};
`;

export const StyledQuoteAlertMessagesList = styled.ul`
  list-style: inside;
  margin-top: ${sizePx(2)};
  color: ${colors.darkBlue75};

  & > li {
    ${typography.Body2}
    & > span:first-child {
      font-weight: 600;
      margin-right: ${sizePx(1)};
    }
  }
`;
export const StyledPriceTag = styled.p`
  & > b {
    ${typography.Title}
    margin-right: ${sizePx(2)};
  }
`;

export const StyledShippingQuoteResult = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizePx(8)};
  margin-top: ${sizePx(3)};
`;

export const StyledBackButton = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  ${typography.Subtitle2}
  color: ${colors.darkBlue75};
  display: flex;
  align-items: center;
  gap: ${sizePx(2)};
  &:hover {
    color: ${colors.darkBlue100};
  }
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${sizePx(4)};
  margin-top: ${sizePx(3)};

  & > div:nth-child(2) {
    margin-bottom: ${sizePx(8)};
  }

  & > div:nth-child(3) {
    margin-bottom: ${sizePx(11)};
  }
`;

export const StyledFormControl = styled.div`
  display: flex;
  flex-direction: column;

  & > span,
  & > div > label[for='city'] {
    ${typography.Subtitle2}
    color: ${colors.darkBlue100};
    margin-bottom: ${sizePx(2)};
  }
  & > div input[id='city'] {
    border-color: ${colors.darkBlue100};
  }
`;

export const StyledFormActions = styled.div`
  & > button[type='submit'] {
    margin: ${sizePx(4)} 0;
    width: 100%;

    &:disabled {
      cursor: not-allowed;
    }
  }
`;
